import React, { Component } from 'react';
import { fetchSimoAccountsList } from 'api';

const withSimoAccounts = (DecoratedComponent) => {
  class WithSimoAccounts extends Component {
    state = {
      simoAccounts: null,
    };

    componentDidMount() {
      this.fetchSimoAccounts();
    }

    fetchSimoAccounts = () => {
      const { userId, simoDeviceId } = this.props;
      let params = {};
      if (userId) {
        params.user_profile_id = userId;
      }
      if (simoDeviceId) {
        params.device_id = simoDeviceId;
      }

      fetchSimoAccountsList(params).then((res) => {
        this.setState({ simoAccounts: res.data });
      });
    };

    render() {
      const { children, ...props } = this.props;
      const { simoAccounts } = this.state;
      const childProps = {
        fetchSimoAccounts: this.fetchSimoAccounts,
        simoAccounts,
        ...props,
      };
      return React.createElement(DecoratedComponent, childProps, children);
    }
  }

  return WithSimoAccounts;
};

export default withSimoAccounts;
